import cash from './cash';
import role from './role';
import member from './member';
import system from './system';

const menus = [...member, ...cash, ...role, ...system];

export default menus;
